import { CreateTaskState } from '@/domains/tasks/types/createTaskSliceTypes';

const initialCreateTaskSteps = {
  taskType: null,
  taskEntity: {
    type: null,
    id: null,
    name: null,
  },
};

export const createTaskInitialState: CreateTaskState = {
  createTaskSteps: initialCreateTaskSteps,
  statuses: {
    isCreateTaskLoading: false,
    isOptionsLoading: false,
  },
  claimOptions: [],
  claimantOptions: [],
  taskTypes: [],
};
